/* eslint-disable */

type Locale = 'en' | 'es';

type Phrase = (l: Locale) => string;

export const i18n_continue_watching: Phrase = locale => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Continue Watching`,
    es: `Seguir viendo`,
  };
  return phrases[locale] || phrases.en || '';
};
